@if (isIDO === false) {
  <app-route-admin-non-ido
    [currentLocation]="location"
  ></app-route-admin-non-ido>
}
@if (isIDO === true) {
  <app-route-admin-ido [currentLocation]="location"></app-route-admin-ido>
}
